import { brandNameOrDefault, formatBRL, formatDateTimeBR, receiptLogoHtml } from './print-receipt.util';

export interface ComprovanteCartao {
  nmPaciente: string;
  cpf: string;
  unidade: string;
  valor: number;
  metodo: string;
  parcelas: number;
  terminal: string;
  dataHora: string;
  nrAdiantamento: number;
  logo: string;
  cdEmpresa: string;
  marca: string;
  usuario: string;
}

export function montarComprovanteCartao(dados: ComprovanteCartao): string {
  const linhaParcelas = dados.parcelas > 1
    ? `<tr><td class="label">Parcelas</td><td class="value">${dados.parcelas}x</td></tr>`
    : '';

  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(dados.logo, dados.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Comprovante de Pagamento</p>
        <p class="subtitle">Pagamento avulso</p>
        <p class="receipt-number">Nº ${dados.nrAdiantamento}</p>
      </div>
    </div>
    <table class="data">
      <tr><td class="label">Paciente</td><td class="value">${dados.nmPaciente || '—'}</td></tr>
      <tr><td class="label">CPF</td><td class="value">${dados.cpf || '—'}</td></tr>
      <tr><td class="label">Unidade</td><td class="value">${dados.unidade || '—'}</td></tr>
      <tr><td class="label">Data/Hora</td><td class="value">${formatDateTimeBR(dados.dataHora)}</td></tr>
      <tr><td class="label">Método</td><td class="value">${dados.metodo}</td></tr>
      ${linhaParcelas}
      <tr><td class="label">Terminal</td><td class="value">${dados.terminal}</td></tr>
      <tr><td class="label">Usuário</td><td class="value">${dados.usuario}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Valor pago</div>
      <div class="amount">${formatBRL(dados.valor)}</div>
    </div>
    <div class="footer">${brandNameOrDefault(dados.marca)} — Comprovante sem valor fiscal</div>
  `;
}
